<!-- src/components/common/SectionHeader.vue -->
<template>
	<h4 class="mb-0 ml-2 mt-1 text-sm/3 text-black">
		{{ title }}
		<slot name="badge"></slot>
	</h4>
</template>

<script setup lang="ts">
	defineProps<{
		title: string;
	}>();
</script>
